import React from "react";
import { useReactToPrint } from "react-to-print";
import ConsoleStore from 'ConsoleStore';


const GeneratePdf = ({ contentRef, isDisable, trackUsageProps }) => {
  const reactToPrintFn = useReactToPrint({ contentRef });
  const handleOnClick = () => {
    if (!isDisable) {
      reactToPrintFn();
      ConsoleStore.trackUsage("PDFExport", "", trackUsageProps);
    }
  }
  return (
    <button
      onClick={handleOnClick}
      className='generate-pdf'
      disabled={isDisable}
    >
      PDF
    </button>
  );
};


export default GeneratePdf;
